import type { StaticSharedField } from './types';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeIntensity(): StaticSharedField {
  return {
    type: FIELD_TYPE_NUMBER,
    propName: 'intensity',
    element: 'intensity',
    placeholderI18nKey: ' ',
    label: <>Emission intensity value:</>,
    subLabel: <span>E.g. 2.96</span>,
    inputMode: 'decimal',
    step: '.01',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOINTENSITY',
        errStr: 'Please enter emissions intensity data',
      },
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRINTENSITYTOOLOW',
        errStr: 'Please enter emissions intensity data',
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRINTENSITYTOOHIGH',
        errStr: 'Please enter emissions intensity data',
        value: 9999,
      },
    ],
  };
}
